import dynamic                                 from "next/dynamic";
import React, {
	useState, useRef, useEffect// , useCallback
} from "react";
import { usePageVisibility } from "react-page-visibility";
import { v4 }                from "uuid";

const Presentation = dynamic ( () => import ( "./presentation" ), { ssr: false } );

const component = ( { count, src, total, name } ) => {

	const [ indexes, setIndex ] = useState ( {} );
	const likeParentRef         = useRef ();
	const isVisible             = usePageVisibility ();

	/* const delay = async ( ms = 1000 ) =>
   *     new Promise ( resolve => setTimeout ( resolve, ms ) ); */

	const __updateLikes = ( prev, next ) => {
		for ( let newIndex = prev; newIndex < next; newIndex ++ ) {
			const idx = v4 ();

			setIndex ( prevIndex => {
				return { ...prevIndex, [idx]: true };
			} );
			/* await delay ( 200 ); */
		}
	};

	/*
     * This is to avoid rerendering on theatre mode toggle
     * as chat container component is called again from layout
     */

	useEffect ( () => {

		if ( !isVisible )
			return;

		__updateLikes ( 0, count );
	}, [ total ] );

	const removeElem = elem => {
		setIndex ( prevIndex => {
			const newIndexes = { ...prevIndex };

			delete newIndexes[elem];

			return newIndexes;
		} );
	};

	const containerWidth = 100;

	return (
		<div
			ref   = { likeParentRef }
			id    = { `emoji-container-${ name }` }
			style = { {
				// height   : "calc(100vh - 285px)",
				height   : "70vh",
				width    : `${ containerWidth }px`,
				right    : `-${ containerWidth }px`,
				position : "absolute",
				zIndex   : 1000,
				bottom   : "50px"
			} }
		>
			{
				Object.keys ( indexes ).map ( elem => {
					return (
						<Presentation
							key        = { elem }
							count      = { count }
							height     = { likeParentRef?.current?.getBoundingClientRect ()?.height }
							id         = { elem }
							removeElem = { removeElem }
							shiftDist  = { containerWidth }
							src        = { src }
							width      = { likeParentRef?.current?.getBoundingClientRect ()?.width }
						/>
					);
				} )
			}
		</div>
	);
};

export default component;
